var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ly-inner"},[_c('idc-page-title',{attrs:{"breadcrumbList":_vm.breadcrumbList}},[_vm._v(_vm._s(_vm.pageTitle))]),_c('table-data-1',{key:Date.now()})],1)}
var staticRenderFns = []

export { render, staticRenderFns }